import { BaseModel } from './base-model.interface';
import BlockModel from './block-model.interface';
import { NotificationInitVariables } from '../template/notifications-model.interface';

export interface ValamarAppModel extends BaseModel {
  variables?: { [key: string]: string } | ValamarAppVariables;
}

export interface ValamarAppVariables {
  AppHeading: string;
  AppText: string;
  AppImage: string;
  AppImageHref: string;
  AppImageAlt: string;
  AppCta1Link: string;
  AppCta2Link: string;
  AppImageHrefSegmentRegex: string;
  AppCta1LinkSegmentRegex: string;
  AppCta2LinkSegmentRegex: string;
}

export class ValamarAppInitVariables implements ValamarAppVariables {
  AppHeading = '';
  AppText = '';
  AppImage = '';
  AppImageHref = '';
  AppImageAlt = '';
  AppCta1Link = '';
  AppCta2Link = '';
  AppImageHrefSegmentRegex = '';
  AppCta1LinkSegmentRegex = '';
  AppCta2LinkSegmentRegex = '';
}

export class ValamarAppInitModel implements BlockModel {
  blockId: string = '';
  count: number = 0;
  name: string = '';
  variables: { [key: string]: string };
  notifications: NotificationInitVariables[];

  constructor() {
    const initVars = new ValamarAppInitVariables();
    this.variables = { ...initVars };
    this.notifications = [new NotificationInitVariables()];
  }
}
